import * as actionTypes from "../actions/actionTypes";

const initialState = {
  details: null,
  errorMessage: null,
  error: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_TELEMEDICINE_PROVIDER_DETAILS: {
      return {
        ...state,
        details: action.payload,
        error: false,
      };
    }
    case actionTypes.FETCH_TELEMEDICINE_PROVIDER_DETAILS_FAILED: {
      return {
        ...state,
        errorMessage: action.error,
        error: true,
      };
    }
    default:
      return state;
  }
};
export default reducer;
